import http from '@/utils/http.js'
/*
 * @DESC:api接口
 */
const GET_SHOP_LIST = "/api/getShopList";//获取门店列表
const DELETE_SHOP = "/api/deleteShop"; // 删除门店
const GET_SHOP_INFO = "/api/getShopInfo"; // 获取门店信息
const SAVE_SHOP_INFO = "/api/saveShopInfo"; //保存门店
const RESET_SHOP_PWD = "/api/resetShopPwd"; // 重置初始密码
const GET_ALL_SHOP_LIST = "/api/getAllShopList";//获取所有门店
const GET_ALL_ITEM_LIST = "/api/getShopItemsById";//所有门店

export default {
	getShopItemsById: async({
		commit
	}, params={}) => {
		try{
			const data = await http.get(GET_ALL_ITEM_LIST, params);
			return data;
		}catch(e){
			throw e
		}
	},
	getShopList: async({
		commit
	}, params={}) => {
		try{
			const data = await http.get(GET_SHOP_LIST, params)
			commit('GET_SHOP_LIST', data)
			return data
		}catch(e){
			throw e
		}
	},
	getShopInfo: ({
		dispatch
	}, params={}) => {
		return http.get(GET_SHOP_INFO, params)
	},
	deleteShop: ({
		dispatch,
	}, params={}) => {
		return http.post(DELETE_SHOP, params)
	},
	saveShopInfo: ({
		dispatch
	}, params={}) => {
		return http.post(SAVE_SHOP_INFO, params)
	},

	resetShopPwd: ({
		commit
	}, params={}) => {
		return http.post(RESET_SHOP_PWD, params)
	},

	getAllShopList: ({
		commit
	}, params={}) => {
		return new Promise((resolve, reject) => {
			http.get(GET_ALL_SHOP_LIST, params)
				.then((data) => {
					commit('GET_ALL_SHOP_LIST',data);
					resolve(data);
				},(err)=>{
					reject(err)
				})
		})
	},
}



// WEBPACK FOOTER //
// ./src/store/mp/shops/shop_manage/actions.js